export default __webpack_public_path__ + "static/media/A12.306773f1.jpg";